// ModelViewer.js
// import React from "react";
// import "@google/model-viewer";
// // import "@google/model-viewer/dist/model-viewer";

// const ModelViewer = ({ src, type }) => {
//   return (
//     <model-viewer
//       src={src}
//       alt="A 3D model"
//       auto-rotate
//       camera-controls
//       ar
//       ar-placement={type === undefined || type === null ? "floor" : type}
//       style={{ height: "50vh" }}
//       ar-scale="fixed"
//     ></model-viewer>
//   );
// };

// export default ModelViewer;

// import React from "react";

// const ModelViewer = ({
//   src,
//   alt,
//   autoRotate,
//   cameraControls,
//   disableZoom,
//   ar,
//   arPlacement,
//   arScale,
//   style,
// }) => {
//   return (
//     <model-viewer
//       src={src}
//       alt={alt}
//       auto-rotate={autoRotate}
//       camera-controls={cameraControls}
//       disable-zoom={disableZoom}
//       ar={ar}
//       ar-placement={arPlacement}
//       ar-scale={arScale}
//       style={style}
//     />
//   );
// };

// export default ModelViewer;

import React from "react";
import "@google/model-viewer";

const ModelViewer = ({ src, type }) => {
  return (
    <model-viewer
      src={src}
      alt="A 3D model"
      auto-rotate
      camera-controls
      ar
      ar-placement={type ?? "floor"} // cleaner nullish coalescing operator
      ar-scale="fixed"
      style={{ height: "50vh" }} // added width so it fits nicely
    />
  );
};

export default ModelViewer;
